<template>
  <div v-if="!loadingPage">
    <div v-if="isAdmin">
      <div v-if="dashboardData.customerAnalytics !== null && dashboardData.salesAnalytics !== null">
        <b-row class="match-height">
          <b-col lg="5" md="12">
            <RemainingSubscription :data="subscriptionData" />
            <VisitationChart :series="currenciesChart" :amount="dashboardData.menuTotalVisits"
              :optionsCategories="optionsCategories" />
          </b-col>
          <b-col lg="7" md="12">
            <b-row class="match-height h-100">
              <b-col xl="6" lg="7" md="12">
                <pieChart :customerAnalytics="dashboardData.customerAnalytics" :salesAnalytics="salesAnalytics.data" />
              </b-col>
              <b-col xl="6" lg="5" md="12">
                <customerProgress :customerAnalytics="dashboardData.customerAnalytics" />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="match-height">
          <b-col md="5">
            <b-row class="match-height">
              <b-col md="6">
                <ratings :dashboardData="dashboardData" />
              </b-col>
              <b-col md="6">
                <Links />
              </b-col>
            </b-row>
            <b-row class="match-height h-100">
              <b-col lg="6" md="6">
                <div
                  v-if="!this.statusCompletionData.isAdminIdentityVerified || !this.statusCompletionData.hasAnyCategory || !this.statusCompletionData.hasAnyProduct">
                  <undoneTasks :statusCompletionData="statusCompletionData" />
                </div>
                <b-card v-else>
                  <div class="d-flex justify-content-center align-items-center h-100">
                    <div>
                      <div class="d-flex justify-content-center">
                        <div @click="changeActiveStatus" class="pointer">
                          <b-avatar size="55" variant="light-primary">
                            <feather-icon size="25" :icon="menuIsActive ? 'EyeIcon' : 'EyeOffIcon'" />
                          </b-avatar>
                        </div>
                      </div>
                      <div class="d-flex align-items-center mt-1 pt-25">
                        <h6 class="text-center">منو :
                          <span class="font-weight-bolder">{{ menuIsActive ? 'فعال' : 'غیرفعال' }}</span>
                        </h6>
                      </div>
                    </div>
                  </div>
                </b-card>
              </b-col>
              <b-col lg="6" md="6">
                <b-card>
                  <div class="d-flex justify-content-center align-items-center h-100">
                    <div>
                      <div class="d-flex justify-content-center">
                        <b-avatar size="55" variant="light-primary">
                          <feather-icon size="25" icon="BoxIcon" />
                        </b-avatar>
                      </div>
                      <div class="d-flex align-items-center justify-content-center mt-1">
                        <h4 class="font-weight-bolder mb-0 mr-50">
                          {{ dashboardData.totalProducts.toLocaleString('fa-IR') }}
                        </h4>
                        <h6 class="font-small-4 mb-0">
                          محصول
                        </h6>
                      </div>
                    </div>
                  </div>
                </b-card>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="7">
            <ternaryLineChart :salesAnalytics="salesAnalytics" />
          </b-col>
        </b-row>
        <b-row class="match-height">
          <b-col lg="3" md="12">
            <todayDate :dateNow="dashboardData.dateNow" />
          </b-col>
          <b-col lg="3" md="12">
            <b-card>
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h4>مانده اعتبار پیامکی</h4>
                  <div class="d-flex align-items-center">
                    <h4 class="font-weight-bolder mb-0 mr-25">{{ dashboardData.smsChargeBalance.toLocaleString('fa-IR')
                    }}</h4>
                    <h6 class="mb-0">ریال</h6>
                  </div>
                </div>
                <div @click="$bvModal.show('account-recharge-2')" class="pointer">
                  <feather-icon size="30" icon="PlusSquareIcon" color="#7367f0" />
                </div>
              </div>
            </b-card>
          </b-col>
          <b-col lg="6" md="12">
            <b-card>
              <b-row>
                <b-col lg="4" md="4">
                  <b-form-group label-for="fromId" class="mb-1 mb-md-0">
                    <b-form-input id="fromId" class="text-center main-input font-weight-bolder pointer"
                      :value="parameters.from ? formatDate(parameters.from) : null" autocomplete="off" name="fromId" />
                    <date-picker v-model="parameters.from" :max="currentDate" format="YYYY-MM-DD"
                      display-format="jYYYY-jMM-jDD" custom-input="#fromId" />
                  </b-form-group>
                </b-col>
                <b-col lg="4" md="4">
                  <b-form-group label-for="toId" class="mb-1 mb-md-0">
                    <b-form-input id="toId" class="text-center main-input font-weight-bolder pointer" name="toId"
                      :value="parameters.to ? formatDate(parameters.to) : null" autocomplete="off" />
                    <date-picker v-model="parameters.to" :max="currentDate" format="YYYY-MM-DD"
                      display-format="jYYYY-jMM-jDD" custom-input="#toId" />
                  </b-form-group>
                </b-col>
                <b-col lg="4" md="4">
                  <b-button variant="info" @click="generalReports" :disabled="loading"
                    class="d-flex justify-content-center w-100">
                    <span>اعمال تاریخ</span>
                    <b-spinner v-if="loading" variant="white" class="ml-50" small></b-spinner>
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <b-row>
          <b-col v-for="(report, index) in generalReport" :key="`report_${index}`" lg="4" md="6">
            <b-card class="card-transaction" no-body>
              <b-overlay :show="loading" variant="transparent" opacity="1" blur="3px" rounded="sm">
                <b-card-body>
                  <div class="transaction-item">
                    <div>
                      <div>
                        <h4 class="mb-50" :class="report.color">
                          {{ report.mode }}
                        </h4>
                      </div>
                      <div class="d-flex align-items-center">
                        <h4 v-if="index == 3" class="font-weight-bolder mb-0" :class="report.color">
                          {{ report.payment }}
                        </h4>
                        <h4 v-else class="font-weight-bolder mb-0" :class="report.color">
                          {{ report.payment.toLocaleString('fa-IR') }}
                        </h4>
                        <h6 class="mb-0 ml-25" :class="report.color">{{ report.types }}</h6>
                      </div>
                    </div>
                    <b-media no-body>
                      <b-media-aside class="mr-0">
                        <b-avatar rounded size="42" :variant="report.avatarVariant">
                          <feather-icon size="20" :icon="report.avatar" />
                        </b-avatar>
                      </b-media-aside>
                    </b-media>
                  </div>
                </b-card-body>
              </b-overlay>
            </b-card>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-card no-body>
              <b-overlay :show="loading" variant="transparent" opacity="1" blur="3px" rounded="sm">
                <b-card-header class="p-2">
                  <h4 class="mb-0 font-weight-bolder">
                    پرفروش ترین محصولات
                  </h4>
                  <h5 @click="$router.push(`/product-orders`)" class="mb-0 text-info pointer">
                    گزارش جامع
                  </h5>
                </b-card-header>
                <hr class="m-0">
                <productChart :itemsList="topSoldProducts" />
              </b-overlay>
            </b-card>
          </b-col>
          <b-col md="6">
            <b-card no-body>
              <b-overlay :show="loading" variant="transparent" opacity="1" blur="3px" rounded="sm">
                <b-card-header class="p-2">
                  <h4 class="mb-0 font-weight-bolder">
                    کم‌فروش ترین محصولات
                  </h4>
                  <h5 @click="$router.push(`/product-orders`)" class="mb-0 text-info pointer">
                    گزارش جامع
                  </h5>
                </b-card-header>
                <hr class="m-0">
                <productChart :itemsList="leastSoldProducts" />
              </b-overlay>
            </b-card>
          </b-col>
          <b-col md="12">
            <b-card no-body>
              <b-overlay :show="loading" variant="transparent" opacity="1" blur="3px" rounded="sm">
                <b-card-header class="p-2">
                  <h4 class="mb-0 font-weight-bolder">
                    جایگاه‌ها
                  </h4>
                  <h5 @click="$router.push(`/table-settings`)" class="mb-0 text-info pointer">
                    تنظیمات
                  </h5>
                </b-card-header>
                <hr class="m-0">
                <b-table v-if="tableReports.length" responsive :items="tableReports" :fields="fieldsTable" class="mb-0"
                  striped>
                  <template #cell(totalSalesAmount)="data">
                    {{ data.item.totalSalesAmount.toLocaleString('fa-IR') }}
                  </template>
                </b-table>
                <div v-else class="text-center py-5">
                  موردی وجود ندارد
                </div>
              </b-overlay>
            </b-card>
          </b-col>
        </b-row>
      </div>
      <div v-else>
        <b-row class="match-height">
          <b-col md="5">
            <RemainingSubscription :data="subscriptionData" />
          </b-col>
          <b-col md="7">
            <b-row class="match-height h-100">
              <b-col md="12">
                <todayDate :dateNow="dashboardData.dateNow" />
              </b-col>
              <b-col md="6">
                <Links />
              </b-col>
              <b-col md="6">
                <div
                  v-if="!this.statusCompletionData.isAdminIdentityVerified || !this.statusCompletionData.hasAnyCategory || !this.statusCompletionData.hasAnyProduct">
                  <undoneTasks :statusCompletionData="statusCompletionData" />
                </div>
                <b-card v-else>
                  <div class="d-flex justify-content-center align-items-center h-100">
                    <div>
                      <div class="d-flex justify-content-center">
                        <div @click="changeActiveStatus" class="pointer">
                          <b-avatar size="55" variant="light-primary">
                            <feather-icon size="25" :icon="menuIsActive ? 'EyeIcon' : 'EyeOffIcon'" />
                          </b-avatar>
                        </div>
                      </div>
                      <div class="d-flex align-items-center mt-1 pt-25">
                        <h6 class="text-center">منو :
                          <span class="font-weight-bolder">{{ menuIsActive ? 'فعال' : 'غیرفعال' }}</span>
                        </h6>
                      </div>
                    </div>
                  </div>
                </b-card>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="match-height">
          <b-col lg="6" md="6">
            <VisitationChart :series="currenciesChart" :amount="dashboardData.menuTotalVisits"
              :optionsCategories="optionsCategories" />
          </b-col>
          <b-col lg="3" md="3">
            <b-card>
              <div class="d-flex justify-content-center align-items-center h-100">
                <div>
                  <div class="d-flex justify-content-center">
                    <b-avatar size="55" variant="light-primary">
                      <feather-icon size="25" icon="ArchiveIcon" />
                    </b-avatar>
                  </div>
                  <div class="d-flex align-items-center justify-content-center mt-1">
                    <h4 class="font-weight-bolder mb-0 mr-50">
                      {{ dashboardData.totalCategories.toLocaleString('fa-IR') }}
                    </h4>
                    <h6 class="font-small-4 mb-0">
                      دسته‌بندی
                    </h6>
                  </div>
                </div>
              </div>
            </b-card>
          </b-col>
          <b-col lg="3" md="3">
            <b-card>
              <div class="d-flex justify-content-center align-items-center h-100">
                <div>
                  <div class="d-flex justify-content-center">
                    <b-avatar size="55" variant="light-primary">
                      <feather-icon size="25" icon="BoxIcon" />
                    </b-avatar>
                  </div>
                  <div class="d-flex align-items-center justify-content-center mt-1">
                    <h4 class="font-weight-bolder mb-0 mr-50">
                      {{ dashboardData.totalProducts.toLocaleString('fa-IR') }}
                    </h4>
                    <h6 class="font-small-4 mb-0">
                      محصول
                    </h6>
                  </div>
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>

    <div v-else class="misc-inner">
      <div class="d-flex justify-content-center w-100 text-center">
        <div>
          <div id="faq-search-filter">
            <b-card no-body class="faq-search"
              :style="{ backgroundImage: `url(${require('@/assets/images/banner/banner.png')})` }">
              <div class="text-center">
                <h3 class="p-3 p-md-5 text-primary">
                  {{ `${userInfo.firstName} عزیز به پنل منوتِک خوش آمدید` }}
                </h3>
              </div>
            </b-card>
          </div>
          <b-img fluid src="@/assets/images/illustration/home.svg" style="width: 56vh;margin-top: -80px;" />
        </div>
      </div>
      <div v-if="permissionToChangePrinter && printers.length" class="pb-4 pt-2">
        <h4 class="text-center">لیست چاپگر ها</h4>
        <h6 class="text-center mb-1">{{ `چاپگر فعال : ${this.defaultPrinter.name}` }}</h6>
        <div class="d-flex justify-content-center flex-wrap">
          <div v-for="(item, index) in printers" :key="`printer_${index}`" class="mt-2 mx-1">
            <div @click="changeDefaultPrinter(item)" class="border border-primary rounded py-1 px-2 text-center pointer"
              :class="{ 'bg-primary text-white': item.id == defaultPrinter.id }">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-------------------------------------- account recharge -------------------------------------->
    <b-modal id="account-recharge-2" title="شارژ حساب پیامکی" centered :hide-footer="true" size="sm"
      title-class="font-weight-bolder">
      <div class="py-1">
        <h6 class="text-center mb-2">مبلغ شارژ حساب خود را انتخاب کنید</h6>
        <div class="d-flex justify-content-center align-items-center flex-wrap">
          <b-badge @click="selectAmountEvent(amount)" :variant="amount == selectAmount ? 'primary' : 'light-primary'"
            v-for="(amount, index) in amounts" :key="`rechargeAmount_${index}`" class="px-2 py-1 mb-1 mx-25 pointer">
            {{ `${(amount / 10).toLocaleString('fa-IR')} تومان` }}
          </b-badge>
        </div>
        <b-button @click="accountRecharge" :disabled="loadingButton || !selectAmount" variant="primary"
          class="d-flex align-items-center justify-content-center w-100 mt-75">
          <span>پرداخت</span>
          <b-spinner v-if="loadingButton" class="ml-50" variant="white" small></b-spinner>
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BCard, BCardHeader, BCardText, BLink, BRow, BCol, BButton, BImg, BAvatar, BBadge, BFormCheckbox, BTable, BMediaAside, BMedia, BMediaBody, BCardBody, BFormInput, BFormGroup, BOverlay, BSpinner } from 'bootstrap-vue';
import VisitationChart from '@/@core/components/home-components/visitationChart.vue';
import TodayDate from '@/@core/components/home-components/todayDate.vue';
import ratings from '@/@core/components/home-components/ratings.vue';
import ternaryLineChart from '@/@core/components/home-components/ternaryLineChart.vue';
import Links from '@/@core/components/home-components/links.vue';
import UndoneTasks from '@/@core/components/home-components/undoneTasks.vue';
import pieChart from '@/@core/components/home-components/pieChart.vue';
import customerProgress from '@/@core/components/home-components/customerProgress.vue';
import productChart from '@/@core/components/home-components/productChart.vue';
import RemainingSubscription from '@/@core/components/home-components/remainingSubscription.vue';
import { storeService } from '@core/services';
import jwt_decode from "jwt-decode";



export default {
  components: {
    BCard,
    BCardText,
    BLink,
    BRow,
    BCol,
    BButton,
    BImg,
    BAvatar,
    BTable,
    VisitationChart,
    RemainingSubscription,
    TodayDate,
    ratings,
    ternaryLineChart,
    Links,
    UndoneTasks,
    pieChart,
    customerProgress,
    BFormCheckbox,
    BMediaAside,
    BMedia,
    BBadge,
    BMediaBody,
    BCardBody,
    BFormInput,
    BFormGroup,
    BCardHeader,
    BSpinner,
    BOverlay,
    productChart
  },
  data() {
    return {
      loadingButton: false,
      loadingPage: true,
      loading: false,
      menuIsActive: false,
      storeId: null,
      salesAnalytics: {
        series: [],
        labels: [],
        data: {}
      },
      amounts: [1000000, 10000000, 30000000, 60000000, 90000000],
      selectAmount: null,
      currenciesChart: [
        {
          data: [],
          name: ""
        }
      ],
      tableReports: [],
      statusCompletionData: {
        hasAnyCategory: false,
        hasAnyProduct: false,
        isAdminIdentityVerified: false,
      },
      dashboardData: {},
      subscriptionData: {
        numberOfDays: 1,
        numberOfDaysLeft: 1,
        subscriptionTitle: null,
        series: [],
        hasReservedSubscription: null
      },
      token: {},
      isAdmin: true,
      userInfo: {
        firstName: null
      },
      currentDate: '',
      parameters: {
        from: null,
        to: null,
      },
      permission: null,
      subscriptionId: null,
      permissionToChangePrinter: false,
      printers: [],
      defaultPrinter: {},
      optionsCategories: null,
      topSoldProducts: [],
      leastSoldProducts: [],
      fieldsTable: [
        {
          key: 'name',
          label: 'نام',
        },
        {
          key: 'totalOrdersCount',
          label: 'تعداد فاکتور ثبت شده',
        },

        {
          key: 'totalSalesAmount',
          label: 'مجموع فروش (ریال)',
        },
      ],
      generalReport: [
        {
          mode: 'فروش خالص',
          types: 'ریال',
          avatar: 'DollarSignIcon',
          avatarVariant: 'light-success',
          payment: null,
          color: 'text-success',
        },
        {
          mode: 'تعداد مشتریان عضو شده',
          types: 'مشتری',
          avatar: 'UserPlusIcon',
          avatarVariant: 'light-secondary',
          payment: null,
          color: '',
        },
        {
          mode: 'تعداد فاکتور ها',
          types: 'عدد',
          avatar: 'ShoppingBagIcon',
          avatarVariant: 'light-secondary',
          payment: null,
          color: '',
        },
        {
          mode: 'پرفروش ترین محصول',
          types: '',
          avatar: 'CoffeeIcon',
          avatarVariant: 'light-secondary',
          payment: null,
          color: '',
        },
        {
          mode: 'اعتبار صادر شده',
          types: 'ریال',
          avatar: 'GiftIcon',
          avatarVariant: 'light-secondary',
          payment: null,
          color: '',
        },
        {
          mode: 'اعتبار استفاده شده',
          types: 'ریال',
          avatar: 'CreditCardIcon',
          avatarVariant: 'light-secondary',
          payment: null,
          color: '',
        },
        {
          mode: 'تخفیف',
          types: 'ریال',
          avatar: 'PercentIcon',
          avatarVariant: 'light-secondary',
          payment: null,
          color: '',
        },
        {
          mode: 'مالیات',
          types: 'ریال',
          avatar: 'CircleIcon',
          avatarVariant: 'light-secondary',
          payment: null,
          color: '',
        },
        {
          mode: 'تعداد عضویت از طریق ارجاع',
          types: 'مشتری',
          avatar: 'UsersIcon',
          avatarVariant: 'light-secondary',
          payment: null,
          color: '',
        },
      ],
    };
  },
  methods: {
    selectAmountEvent(amount) {
      this.selectAmount = amount
    },
    accountRecharge() {
      this.loadingButton = true;
      storeService.smsAccountRecharge(this.storeId, { amount: this.selectAmount }).then(({ data }) => {
        localStorage.setItem("gatewayData", JSON.stringify(data));
        this.$router.push(`/redirect-to-gateway`)
      })
        .catch(() => {
          this.loadingButton = false
        });
    },
    getPrinter() {
      storeService.getPrinter(this.storeId).then(({ data }) => {
        this.printers = data.items
        this.getUserInfo()
      })
    },
    getUserInfo() {
      storeService.getUserInfo(this.storeId).then(({ data }) => {
        this.defaultPrinter = data.defaultPrinter
        this.permissionToChangePrinter = true
        this.loadingPage = false
        if (this.printers.length) {
          localStorage.setItem("certificateId", data.defaultPrinter.certificateId)
          localStorage.setItem("printerModel", data.defaultPrinter.model)
        }
      })
    },
    changeActiveStatus() {
      storeService.changeActiveStatus(this.storeId, { isActive: !this.menuIsActive }).then(({ data }) => {
        this.menuIsActive = !this.menuIsActive
        this.$notif({ type: 'success', title: 'وضعیت منو با موفقیت تغییر کرد' })
      })
        .catch((err) => {
          this.$notif({ type: 'error' })
        })
    },
    getCompletionStatus() {
      storeService.getCompletionStatus(this.storeId).then(({ data }) => {
        this.statusCompletionData = data
        this.getSubscriptionInfo()
      })
    },
    getDashboardData() {
      storeService.getDashboardData(this.storeId).then(({ data }) => {
        this.dashboardData = data
        this.currenciesChart[0].data = data.menuVisitsLastWeek
        this.menuIsActive = data.isActive
        localStorage.setItem("urlName", data.urlName)
        if (this.dashboardData.customerAnalytics !== null && this.dashboardData.salesAnalytics !== null) {
          for (let index in this.dashboardData.salesAnalytics.sellsPerDay) {
            this.salesAnalytics.labels[index] = new Date(this.dashboardData.salesAnalytics.sellsPerDay[index].date).toLocaleDateString('fa-IR-u-ca-persian', { month: 'numeric', day: 'numeric' })
          }
          this.salesAnalytics.series = [
            {
              name: 'فروش خالص',
              data: (this.dashboardData.salesAnalytics.sellsPerDay || []).map(item => item.value ?? 0)
            },
            {
              name: 'تخفیف',
              data: (this.dashboardData.salesAnalytics.discountsPerDay || []).map(item => item.value ?? 0)
            },
            {
              name: 'اعتبار صادر شده',
              data: (this.dashboardData.salesAnalytics.cashbacksPerDay || []).map(item => item.value ?? 0)
            }
          ]
          this.salesAnalytics.data.ordersWithoutCustomerAmount = this.dashboardData.salesAnalytics.ordersWithoutCustomer.totalOrdersAmount
          this.salesAnalytics.data.ordersWithoutCustomerPercentage = this.dashboardData.salesAnalytics.ordersWithoutCustomer.ordersPercentage
          this.salesAnalytics.data.totalOrdersAmount = this.dashboardData.salesAnalytics.totalOrdersAmount
          this.salesAnalytics.data.totalOrdersCount = this.dashboardData.salesAnalytics.totalOrdersCount
          this.generalReports()
        }
        else {
          this.loadingPage = false
        }
      })
    },
    getSubscriptionInfo() {
      storeService.getSubscriptionInfo(this.storeId).then(({ data }) => {
        let percent = (data.current.remainDays / data.current.totalDays) * 100
        this.subscriptionData.series.push(Math.ceil(percent))
        this.subscriptionData.numberOfDays = data.current.totalDays
        this.subscriptionData.numberOfDaysLeft = data.current.remainDays
        this.subscriptionData.subscriptionTitle = data.current.subscription.title
        this.subscriptionData.hasReservedSubscription = data.hasReservedSubscription
        this.getDashboardData()
      })
    },
    generalReports() {
      this.loading = true
      storeService.generalReports(this.storeId, this.parameters.from, this.parameters.to).then(({ data }) => {
        if (this.loadingPage) {
          this.topSoldProducts = data.topSoldProducts
          this.leastSoldProducts = data.leastSoldProducts
          this.generalReport[0].payment = data.totalSellsAmount
          this.generalReport[1].payment = data.newCustomersCount
          this.generalReport[2].payment = data.newOrdersCount
          this.generalReport[3].payment = data.topSoldProducts.length ? data.topSoldProducts[0].name : '-'
          this.generalReport[4].payment = data.totalCashbacksAmount
          this.generalReport[5].payment = data.totalUsedWalletsAmount
          this.generalReport[6].payment = data.totalDiscountsAmount
          this.generalReport[7].payment = data.totalTaxesAmount
          this.generalReport[8].payment = data.newReferredCustomers
          this.tableReports = data.tableReports
          this.loading = false
        }
        else {
          setTimeout(() => {
            this.topSoldProducts = data.topSoldProducts
            this.leastSoldProducts = data.leastSoldProducts
            this.generalReport[0].payment = data.totalSellsAmount
            this.generalReport[1].payment = data.newCustomersCount
            this.generalReport[2].payment = data.newOrdersCount
            this.generalReport[3].payment = data.topSoldProducts.length ? data.topSoldProducts[0].name : '-'
            this.generalReport[4].payment = data.totalCashbacksAmount
            this.generalReport[5].payment = data.totalUsedWalletsAmount
            this.generalReport[6].payment = data.totalDiscountsAmount
            this.generalReport[7].payment = data.totalTaxesAmount
            this.generalReport[8].payment = data.newReferredCustomers
            this.tableReports = data.tableReports
            this.loading = false
          }, 369)
        }
        this.loadingPage = false
      })
    },
    changeDefaultPrinter(item) {
      if (item.id != this.defaultPrinter.id) {
        storeService.changeDefaultPrinter(this.storeId, { printerId: item.id }).then(({ data }) => {
          this.defaultPrinter = item
          localStorage.setItem("certificateId", this.defaultPrinter.certificateId)
          localStorage.setItem("printerModel", this.defaultPrinter.model)
          this.$notif({ type: 'success', title: 'چاپگر با موفقیت تغییر کرد' });
        })
      }
    },
    formatDate2(date) {
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
    },
    formatDate(dateString) {
      const [year, month, day] = dateString.split('-');
      return new Date(year, parseInt(month) - 1, day).toLocaleDateString('fa-IR');
    },
  },
  mounted() {
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);
    this.parameters.from = this.formatDate2(today);
    this.parameters.to = this.formatDate2(tomorrow);
    this.currentDate = this.parameters.to;
    const fmt = new Intl.DateTimeFormat('fa-IR-u-ca-persian', {
      month: 'numeric',
      day: 'numeric'
    });
    const last7Days = Array.from({ length: 7 }, (_, i) => {
      const d = new Date(today);
      d.setDate(today.getDate() - (i + 1));
      return fmt.format(d);
    }).reverse();
    this.optionsCategories = last7Days
    const accessToken = localStorage.getItem("accessToken")
    this.token = jwt_decode(accessToken);
    let userIsLogin = localStorage.getItem("userIsLogin")
    if (userIsLogin) {
      const storeId = localStorage.getItem("storeId")
      if (storeId == 'undefined' || storeId == null) {
        this.storeId = this.token.storeid
        localStorage.setItem("storeId", this.storeId)
      }
      else {
        this.storeId = localStorage.getItem("storeId")
      }
      if (this.token.permission.length) {
        this.isAdmin = false
        let userInfo = JSON.parse(localStorage.getItem("userInfo"));
        if (userInfo != null) {
          if (userInfo.firstName) {
            this.userInfo = userInfo
          }
        }
        this.permission = this.token.permission;
        this.subscriptionId = this.token.current_subscription_id;
        if (this.token.has_printer_access) {
          this.getPrinter()
        }
        else {
          this.loadingPage = false
        }
      }
      else {
        this.isAdmin = true
        this.getCompletionStatus()
      }
    }
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-faq.scss';
</style>